// extracted by mini-css-extract-plugin
module.exports = {"text":"NotifyAgent_text__317_f","top":"NotifyAgent_top__3vTN8"};